import React, {useState, useMemo} from "react"
import useTags from "hooks/useTags"
import Tag from "components/Tag"


export default function RescuerSearchTags(props) {

    const {addTag} = props
    const {tags} = useTags()
    const [tagFilter, setTagFilter] = useState("")
    
    const filteredTags = useMemo(() => {
        const filter = tagFilter.toLowerCase()
        return tags.filter(tag => tag.name.includes(filter) || tag.description.toLowerCase().includes(filter))
    }, [tagFilter, tags])


    return <div id="tags">    
        <div id="tag-filter">
            <input type="text" value={tagFilter} placeholder="Filtriranje tagova..." onChange={event => setTagFilter(event.target.value)}/>
        </div>
        
        <div id="tag-list">
            {filteredTags.map(tag => <Tag key={tag.name} tag={tag} onClick={() => addTag(tag.name)}/>)}
        </div>
    </div>
}